import {UserContextDetails} from "@bounce/shared/consumer/declarations";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {AxiosResponse} from "axios";
import {axiosConsumerAppInstance} from "~/api/ConsumerApiManager";

type Variables = {userId?: string; linkId?: string};

type Data = UserContextDetails;

export const getConsumerContext = async (variables: Variables): Promise<Data> => {
  if (!variables.userId) {
    // @ts-ignore
    return;
  }
  const result = await axiosConsumerAppInstance.get<Data, AxiosResponse<Data>>(`/user/context/${variables.userId}`, {
    params: {lid: variables.linkId},
  });
  return result.data;
};

export const useGetConsumerContext = (
  variables: Variables,
  options?: BaseQueryOptions<Data, Variables>
): BaseUseQueryResult<Data> => {
  const queryKey = variables.userId ? ["user", variables.userId, "context"] : ["invalid-user"];
  return useBaseQuery<Data, Variables>(queryKey, getConsumerContext, variables, options);
};
